import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Truck } from 'lucide-react';
import { navLinks, company } from '../mock/mock';

const Navbar = ({ transparent = false }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const dark = transparent && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        dark ? 'bg-transparent' : 'bg-white/95 backdrop-blur border-b border-black/10'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center group">
          <img
            src="/media/caprock-logo.png"
            alt="Caprock Logistics Group"
            className={`h-12 lg:h-14 w-auto transition-all duration-300 ${
              dark ? 'invert' : ''
            }`}
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => {
            const active = location.pathname === l.href;
            return (
              <Link
                key={l.href}
                to={l.href}
                className={`font-mono-tech text-[11px] uppercase tracking-[0.22em] transition-colors relative ${
                  dark ? 'text-white/85 hover:text-white' : 'text-black/70 hover:text-black'
                } ${active ? '!text-current' : ''}`}
              >
                {l.label}
                {active && (
                  <span
                    className={`absolute -bottom-2 left-0 right-0 h-[1.5px] ${
                      dark ? 'bg-white' : 'bg-black'
                    }`}
                  />
                )}
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${company.phone}`}
            className={`font-mono-tech text-[11px] tracking-[0.22em] uppercase ${
              dark ? 'text-white/85 hover:text-white' : 'text-black/70 hover:text-black'
            }`}
          >
            {company.phone}
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden p-2 ${dark ? 'text-white' : 'text-black'}`}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-black/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                className="font-mono-tech text-xs uppercase tracking-[0.22em] text-black/80"
              >
                {l.label}
              </Link>
            ))}
            <a
              href={`tel:${company.phone}`}
              className="font-mono-tech text-xs uppercase tracking-[0.22em] text-black/60 pt-2 border-t border-black/10"
            >
              {company.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
